import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import TableContainer from "../../../components/layout/table-container/table-container";
import { changeDistriRequestList } from "../../../redux/actions/customerActions";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import CustomerDistriReqListTableData from "./CustomerDistriReqListTableData";
import UpArrow from "../../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../../assets/icons/filterArrowDown.svg";
import { useNavigate, useParams } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const CustomerDistriReqListTable = ({ search, status, page_no }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [changeDistriRequestListData, setChangeDistriRequestListData] =
    useState("");
  const [loading, setLoading] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      changeDistriRequestList({ page, search, status }, onSuccess, onError)
    );
  }, [page, search, status, dispatch]);

  const onSuccess = (data) => {
    setLoading(false);
    setChangeDistriRequestListData(data.data.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"10%"}>
              Jivini’s Doctor Code
            </th>
            <th className="table-heads " width={"10%"}>
              Jivini’s Pharmacy Code
            </th>
            <th className="table-heads " width={"10%"}>
              Doctor Name
            </th>
            <th className="table-heads " width={"10%"}>
              Pharmacy Name
            </th>
            <th className="table-heads " width={"10%"}>
              City
            </th>
            <th className="table-heads " width={"10%"}>
              Manufacturer
            </th>
            <th className="table-heads " width={"10%"}>
              Division
            </th>
            <th className="table-heads " width={"15%"}>
              Distributor
            </th>
            <th ref={componentRef} className="table-heads " width={"15%"}>
              <span
                className={
                  openStatus ? "Medium_Purple cursor_pointer" : "cursor_pointer"
                }
                onClick={() => setOpenStatus(!openStatus)}
              >
                <span className={status ? "Medium_Purple fw_700" : ""}>
                  Status
                </span>
                {openStatus ? (
                  <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                ) : (
                  <img src={DownArrow} className="mx-1" alt="v" />
                )}
              </span>
              {openStatus ? (
                <div className=" position-relative">
                  <div
                    className="position-absolute status-container d-flex gap-3 px-3"
                    style={{ right: "0" }}
                  >
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="approved"
                        name="status"
                        value={"approved"}
                        checked={status === "approved"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/customers/distributor-request?page=1${
                              search ? `&search=${search}` : ""
                            }&status=approved`
                          );
                        }}
                      />
                      <label
                        htmlFor="approved"
                        className={
                          status === "approved"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Approved
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="rejected"
                        name="status"
                        value={"rejected"}
                        checked={status === "rejected"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/customers/distributor-request?page=1${
                              search ? `&search=${search}` : ""
                            }&status=rejected`
                          );
                        }}
                      />
                      <label
                        htmlFor="rejected"
                        className={
                          status === "rejected"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Rejected
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2"
                        type="radio"
                        id="pending"
                        name="status"
                        value={"pending"}
                        checked={status === "pending"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/customers/distributor-request?page=1${
                              search ? `&search=${search}` : ""
                            }&status=pending`
                          );
                        }}
                      />
                      <label
                        htmlFor="pending"
                        className={
                          status === "pending" ? "color_262c3d" : "color_747f9e"
                        }
                      >
                        pending
                      </label>
                    </div>
                    <button
                      className="filter-btn px-2 py-0 my-2 fs_12"
                      style={{ height: "28px" }}
                      onClick={() => {
                        setOpenStatus(!openStatus);
                        navigate(
                          `/customers/distributor-request?page=1${
                            search ? `&search=${search}` : ""
                          }`
                        );
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              ) : null}
            </th>
            <th className="table-heads " width={"12%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : changeDistriRequestListData?.distributorChangeRequest?.length >
            0 ? (
            <>
              {changeDistriRequestListData?.distributorChangeRequest?.map(
                (eachRow, index) => (
                  <CustomerDistriReqListTableData
                    key={eachRow.id}
                    data={eachRow}
                    index={index}
                    currentPage={
                      changeDistriRequestListData?.pagination?.currentPage
                    }
                  />
                )
              )}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {changeDistriRequestListData?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={changeDistriRequestListData?.pagination?.currentPage}
            totalPages={changeDistriRequestListData?.pagination?.totalPages}
            path={"/customers/distributor-request/"}
            search={search ?? ""}
            filters={`&${status !== null ? status : ""}`}
          />
        )}
      </div>

      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default CustomerDistriReqListTable;
